$(function(){
	$('#actualityToggle').click(function(){
		$(".actuality-link").addClass('active')

		$(".actualities").addClass('active')

		$(".slider-container").addClass('active')
		setTimeout(function(){
			$(".actualities-block").addClass('active')
		}, 200)
	})
	$('#actualityClose').click(function(){

		setTimeout(function(){
			$(".actuality-link").removeClass('active')
			$(".actualities").removeClass('active')
			$(".slider-container").removeClass('active')
		}, 200)			

		$(".actualities-block").removeClass('active')
	})
});